import ky, { HTTPError, type Options } from "ky"

export class APIError extends Error {
  public info?: unknown

  public response?: Response

  constructor(message?: string) {
    super(message)
    this.name = `APIError`
  }
}

export async function formatAPIError(unknownError: unknown) {
  if (unknownError instanceof HTTPError) {
    const { response } = unknownError
    const error = new APIError(`An error occurred while fetching the data.`)
    error.response = response
    if (response.headers.get(`content-type`)?.includes(`application/json`)) {
      error.info = await response.json().catch()
    }

    return error
  }

  return unknownError
}

export async function prepareRequestForMutation(request: Request) {
  if ([`POST`, `PUT`, `PATCH`, `DELETE`].includes(request.method)) {
    const session: { csrf: string } = await ky
      .get(`/api/v1/session/csrf`)
      .json()
    request.headers.set(`X-CSRFToken`, session.csrf)
  }
}

export const api = ky.extend({
  prefixUrl: `/api/v1/`,
  timeout: false,
  hooks: {
    beforeRequest: [
      async request => {
        await prepareRequestForMutation(request)
      }
    ]
  }
})

export async function sendApiData<ResponseType = string>(
  endpoint: string,
  options: Omit<Options, `method`> & {
    method: `POST` | `PUT` | `PATCH` | `DELETE`
  }
): Promise<ResponseType> {
  try {
    const response = await api(endpoint, options)
    if (response.headers.get(`content-type`)?.includes(`application/json`)) {
      try {
        const json: ResponseType = await response.json()
        return json
        // eslint-disable-next-line no-empty
      } catch {}
    }

    return response as unknown as ResponseType
  } catch (error) {
    throw await formatAPIError(error)
  }
}
